<script>
    import { onMount } from "svelte";
    onMount(() => {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
    });
</script>

<div class="ads-widget-container">
    <ins
        class="adsbygoogle"
        style="display:block"
        data-ad-client="ca-pub-1355267016342705"
        data-ad-slot="7941365661"
        data-ad-format="auto"
        data-full-width-responsive="true"
    />
</div>

<style>
    /* ... */
</style>
